import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import BundlesCommon from './BundlesCommon';
import BundlesCommon2 from './BundlesCommon2';
import BundlesCommon3 from './BundlesCommon3';

export default function TabBundles() {
    const { t } = useLang('theProduct.Bundles');
    return (
        <>
            <EfSpec></EfSpec>
            <EfTitle>{t('title1')}</EfTitle>
            <BundlesCommon></BundlesCommon>
            <EfSpec></EfSpec>
            <EfTitle>{t('title2')}</EfTitle>
            <BundlesCommon2></BundlesCommon2>
            <BundlesCommon3></BundlesCommon3>

            <EfSpec></EfSpec>
        </>
    );
}
